import { render, staticRenderFns } from "./HMTag.vue?vue&type=template&id=53cf67da&scoped=true&"
import script from "./HMTag.vue?vue&type=script&lang=js&"
export * from "./HMTag.vue?vue&type=script&lang=js&"
import style0 from "./HMTag.vue?vue&type=style&index=0&id=53cf67da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf67da",
  null
  
)

export default component.exports